module.exports = __webpack_public_path__ + "img/178.b093341c.jpg";